import Span from "@/components/ui/Span";

const CustomTextInput = ({
  name,
  value,
  onChange,
  placeholder,
  type,
  className = "",
  label,
  showEmptyError = false,
  emptyErrorMsg,
  onKeyPress
}) => {
  return (
    <div className="w-full">
      <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
        {label}
      </label>
      <input
        autoComplete="none"
        name={name}
        className={`px-2 py-1.5 dark:bg-brown bg-light_bg_grey rounded border focus:outline-0 focus:ring-1 focus:ring-blue-600 w-full placeholder:dark:text-neutral-500 transition duration-300 ${className}`}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        type={type}
        onKeyDown={onKeyPress}
      />
      {showEmptyError && value === "" && (
        <Span className="!text-red px-1">{emptyErrorMsg}</Span>
      )}
    </div>
  );
};

export default CustomTextInput;
